/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import * as axios from 'axios';
import router from '../router'
import { Toast } from 'vant';

// 环境的切换
if (process.env.ENV == 'development') {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
} else if (process.env.ENV == 'production') {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_API
}

// 请求超时时间
axios.defaults.timeout = 60000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = localStorage.getItem('token')
        token && (config.headers.Authorization = token);
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
         if (response.status === 200) {
            if (response.data.code === 200) {
                return Promise.resolve(response);
            }
            if (response.data.code === 401) {

                // Toast.fail('登录过期，请重新登录')

                // 清除token                    
                localStorage.removeItem('token');
                localStorage.removeItem('userInfo');
                router.push({
                    path: '/',
                });
                return Promise.resolve(response);
            }
            if (response.data.code === 500) {
                Toast({
                    message: response.data.msg,
                });
                return Promise.resolve(response);
            }

        }
        return Promise.resolve(response);

    },
    // 服务器状态码不是200的情况    
    error => {
        if (error.response.code) {
            switch (error.response.data.code) {
                // 401: 未登录                
                // 未登录则跳转登录页面，并携带当前页面的路径                
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401:

                    Toast.fail('登录过期，请重新登录')
                    // 清除token                    
                    localStorage.removeItem('token');
                    localStorage.removeItem('currentDay')
                    localStorage.removeItem('userInfo')
                    break;
                // 403 token过期                
                // 登录过期对用户进行提示                
                // 清除本地token和清空vuex中token对象                
                // 跳转登录页面                
                case 403:

                    Toast.fail('登录过期，请重新登录')
                    // 清除token                    
                    localStorage.removeItem('token');
                    localStorage.removeItem('currentDay')
                    localStorage.removeItem('userInfo')
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;
                // 404请求不存在                
                case 404:

                    Toast.fail('网络请求不存在')
                    break;
                // 其他错误，直接抛出错误提示                
                // default:

                // Toast.fail(error.response.data.msg)

            }

        }
        // return Promise.resolve(error.response);
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
    return axios.get(url, {
        params: params
    }).then(res => {
        return Promise.resolve(res.data);
    })

}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    return axios.post(url, params)
        .then(res => {
            return Promise.resolve(res.data);
        })
}
export function uploaded(url, params) {
    return axios.post(url, params, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(res => {
        return Promise.resolve(res.data);
    })

}